import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
export class SynapseDrawer extends LitElement {
    static get styles() {
        return css `
      .drawer {
        width: 360px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: fixed;
        top: 0;
        right: 0;
        transform: translate(100%);
        transition: 0.2s;
        background-color: var(--drawer-bg-color, var(--synapse-color-neutral-1));
        z-index: 100;
        border-left: 1px solid var(--drawer-border-color, var(--border-color-default));
        overflow: hidden;
      }

      .drawer-header {
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
      }

      .drawer-open {
        transform: translate(0);
      }

      .drawer-body {
        flex: 1;
      }

      .drawer-title {
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        color: var(--drawer-text-color, var(--synapse-color-neutral-8));
      }

      slot[name='close']::slotted(*) {
        margin-top: 12px;
        cursor: pointer;
        color: var(--drawer-close-icon-color, var(--synapse-color-neutral-4));
      }

      slot[name='close']::slotted(*:hover) {
        color: var(--drawer-close-icon-hovered, var(--synapse-color-neutral-8));
      }

      @media (hover: none) and (pointer: coarse) and (max-width: 400px) {
        .drawer {
          width: 100%;
        }
      }

      @media (max-width: 675px) {
        .drawer {
          width: 100%;
        }
      }
    `;
    }
    static get properties() {
        return {
            open: { type: Boolean, reflect: true },
            headerTitle: { type: String, attribute: 'header-title' },
        };
    }
    constructor() {
        super();
        this.open = false;
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.compareElement = this.compareElement.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('click', this.onOutsideClick);
    }
    onOutsideClick(event /** @type {FocusEvent} */) {
        if (!this.open)
            return;
        if (this.open && !event.composedPath().some(this.compareElement)) {
            this.closeDrawer(event);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this.onOutsideClick);
    }
    closeDrawer(event) {
        this.dispatchEvent(new CustomEvent('drawer-close', { detail: { event }, bubbles: true, composed: true }));
    }
    compareElement(element) {
        if (this.hasAttribute('id')) {
            return element.id === this.getAttribute('id');
        }
        return element.tagName === this.tagName;
    }
    render() {
        return html `
      <slot name="toggle"></slot>
      <div
        class=${classMap({
            drawer: true,
            'drawer-open': this.open,
        })}
        part="body"
      >
        <slot name="drawer-content">
          <div class="drawer-header">
            <span class="drawer-title">${this.headerTitle}</span>
            <slot name="close"></slot>
          </div>
          <div class="drawer-body">
            <slot></slot>
          </div>
        </slot>
      </div>
    `;
    }
}
customElements.define('synapse-drawer', SynapseDrawer);
